import { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";

const LoginCallback = () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    //console.log("LoginCallback: inProgress =", inProgress, "isAuthenticated =", isAuthenticated);

    // Wait for MSAL to finish processing the redirect
    if (inProgress === "none") {
      if (isAuthenticated) {
        const lastKnownPath = localStorage.getItem("lastKnownPath");
        // Only allow relative paths starting with "/"
        if (lastKnownPath && /^\/(?!\/)/.test(lastKnownPath)) {
          localStorage.removeItem("lastKnownPath");
          navigate(lastKnownPath, { replace: true });
        }
        else
          navigate("/home", { replace: true });
      } else {
        //console.log("Not authenticated, redirecting to login");
        navigate("/home", { replace: true });
      }
    }
  }, [inProgress, isAuthenticated, navigate]);

  return <LoaderSpin isVisible={true} />;
};

export default LoginCallback;


